import React from 'react'
import { useNavigate } from 'react-router-dom'
import FavoriteMenuIcon from '../LotusMainSidebar/FavoriteMenuIcon'
import {
  LOTUS_CASINO_FAVORITES_PATH,
  LOTUS_PROVIDERS_PATH,
} from '../../constants/mainCasinoRoute'
import authService from '../../services/auth.service'
import '../../apollo-icons.css'
import './LotusCasinoLobbyNav.css'

export type LotusCasinoLobbyNavProps = {
  preLoginMode?: boolean
  onFavorites?: () => void
  onProviders?: () => void
  onLoginRequired?: () => void
}

const LotusCasinoLobbyNav: React.FC<LotusCasinoLobbyNavProps> = ({
  preLoginMode = false,
  onFavorites,
  onProviders,
  onLoginRequired,
}) => {
  const navigate = useNavigate()
  const loggedIn = !preLoginMode && authService.isLoggedIn()

  const goFavorites = () => {
    if (preLoginMode) {
      onLoginRequired?.()
      return
    }
    if (onFavorites) {
      onFavorites()
      return
    }
    navigate(LOTUS_CASINO_FAVORITES_PATH)
  }

  const goProviders = () => {
    if (onProviders) {
      onProviders()
      return
    }
    navigate(LOTUS_PROVIDERS_PATH)
  }

  return (
    <div className="lotus-casino-lobby-nav casino-lobby" aria-label="Casino lobby shortcuts">
      <div className="lotus-casino-lobby-nav__title" />
      <div className="lotus-casino-lobby-nav__buttons">
        {loggedIn || preLoginMode ? (
          <button
            type="button"
            className="lotus-casino-lobby-nav__item favorite"
            onClick={goFavorites}
          >
            <span className="lotus-casino-lobby-nav__icon providers-icon" aria-hidden>
              <FavoriteMenuIcon />
            </span>
            Favorites
            <span className="lotus-casino-lobby-nav__separator" aria-hidden />
          </button>
        ) : null}
        <button
          type="button"
          className="lotus-casino-lobby-nav__item providers"
          onClick={goProviders}
        >
          <i className="providers-icon icon-filter" aria-hidden />
          Providers
        </button>
      </div>
    </div>
  )
}

export default LotusCasinoLobbyNav
